import { render, staticRenderFns } from "./MultyInputsFields.vue?vue&type=template&id=40bf8792"
import script from "./MultyInputsFields.vue?vue&type=script&lang=js"
export * from "./MultyInputsFields.vue?vue&type=script&lang=js"
import style0 from "./MultyInputsFields.vue?vue&type=style&index=0&id=40bf8792&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports